/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Placement_TitleInputs */

const en_directory_promotion_placement_title = /** @type {(inputs: Directory_Promotion_Placement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose where the promotion appears`)
};

const zh_directory_promotion_placement_title = /** @type {(inputs: Directory_Promotion_Placement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择推广展示位置`)
};

/**
* | output |
* | --- |
* | "Choose where the promotion appears" |
*
* @param {Directory_Promotion_Placement_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_placement_title = /** @type {((inputs?: Directory_Promotion_Placement_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Placement_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_placement_title(inputs)
	return zh_directory_promotion_placement_title(inputs)
});
export { directory_promotion_placement_title as "directory.promotion.placement_title" }